/** Protocol schemas — SPEC §21 */

/** Honest suite id — hybrid KEM + symmetric chain ratchet (not Triple Ratchet). */
export const SUITE_ID = "X25519_MLKEM768_SYMMETRIC_RATCHET_XCHACHA20POLY1305";
export const PROTOCOL_VERSION = 1;

export type DeliveryState =
  | "draft"
  | "queued"
  | "sent"
  | "backed_up"
  | "delivered"
  | "read"
  | "failed"
  | "attention";

/** Delivery tier — NET-REL-003 approved-route expansion / NET-REL-006 community boundary. */
export type RelayTier = "primary" | "fallback" | "community";

export interface BootstrapRelay {
  url: string;
  provider: string;
  region: string;
  /** "dev" = AUTH challenge required; "open" = no auth handshake (community relays). */
  auth: string;
  tier?: RelayTier;
}

export interface BootstrapDocument {
  version: number;
  valid_from: string;
  expires_at: string;
  min_client_protocol: number;
  recommended_client_protocol: number;
  relays: BootstrapRelay[];
  turn: { url: string; credential_endpoint: string }[];
  features: { public_mesh: boolean; calls: boolean };
  signature: string;
}

export interface AppEnvelope {
  v: number;
  suite: string;
  conversation_hint: string;
  sender_device_hint: string;
  epoch: number;
  message_number: number;
  previous_chain_length: number;
  pq_rekey?: string;
  padding_class: number;
  ciphertext: string;
}

export interface DeliveryReceipt {
  v: number;
  message_id: string;
  recipient_device: string;
  state: "delivered" | "read";
  logical_time: number;
  proof: string;
}

export interface TransportEvent {
  id: string;
  pubkey: string;
  created_at: number;
  kind: number;
  tags: string[][];
  content: string;
  sig: string;
}

export const CONTENT_TYPE_TEXT = 1;
export const CONTENT_TYPE_REACTION = 2;
export const CONTENT_TYPE_EDIT = 3;
export const CONTENT_TYPE_DELETE = 4;
export const CONTENT_TYPE_RECEIPT = 5;
export const CONTENT_TYPE_GROUP_CONTROL = 6;
export const CONTENT_TYPE_DEVICE_CONTROL = 7;
/**
 * Empty session-recovery ping (no UI): sent when a contact's message could not
 * be read by any session, so the peer adopts our (restarted) session.
 */
export const CONTENT_TYPE_SYNC = 13;

export * from "./groups";
export * from "./devices";
export * from "./attachments";
export * from "./imageMetadata";
export * from "./profile";
export * from "./schemas";
export * from "./signaling";
export * from "./groupCrypto";
export * from "./groupAuth";
export * from "./calls";
export * from "./attachmentPolicy";
export * from "./stickers";
export * from "./gifProvider";
export * from "./transportEvent";
export * from "./relayAuth";
// attachments re-exported via ./attachments (CONTENT_TYPE_ATTACHMENT etc.)
export * from "./appPayload";
